import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class PurchaseOrder extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */

  getOne(id) {
    const url = this._getFullURL("/cmms/purchase-order/" + id);
    return this._secureFetch(url);
  }

  update(id,payload,photoFile) {
    const url = this._getFullURL("/cmms/purchase-order/"+id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);
    
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  delete(id) {
    const url = this._getFullURL("/cmms/purchase-order/"+id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  sendPdf(id,payload) {
    const url = this._getFullURL("/cmms/purchase-order/pdf/"+id);

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }


  updateStatus(id,payload) {
    const url = this._getFullURL("/cmms/purchase-order/status/"+id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/purchase-order?" + queryParam);
    return this._secureFetch(url);
  }
  create(payload, photoFile) {
    const url = this._getFullURL("/cmms/purchase-order");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }


  import(payload) {
    const url = this._getFullURL("/cmms/purchase-order/import");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }


}
